import { t as o } from "./index739.mjs";
import { i as l } from "./index761.mjs";
import { c as s } from "./index807.mjs";
import { w as c } from "./index760.mjs";
var u = o, f = l, t = s, i = c, m = i("toStringTag"), T = Object, v = t(function() {
  return arguments;
}()) === "Arguments", g = function(a, r) {
  try {
    return a[r];
  } catch {
  }
}, b = u ? t : function(a) {
  var r, e, n;
  return a === void 0 ? "Undefined" : a === null ? "Null" : typeof (e = g(r = T(a), m)) == "string" ? e : v ? t(r) : (n = t(r)) === "Object" && f(r.callee) ? "Arguments" : n;
};
export {
  b as c
};
